import { SalesIQAuth } from "./SalesIQAuth";
export class SalesIQUser extends SalesIQAuth {
  type = "registered_visitor";
  constructor(userId) {
    super();
    this.userId = userId;
  }
}
export class SalesIQGuestUser extends SalesIQAuth {
  type = "guest";
}
//# sourceMappingURL=index.js.map